module.exports = __webpack_public_path__ + "static/media/logo.6362b54b.png";